<template>
  <div id="app">
    <div class="main">
      <el-card class="box-card leftcon left">
        <div class="left-con">
          <div class="pd" v-if="subject.judge_status">
            <div class="title">判 断</div>
            <div v-for="(item,key) in subject.judge" :key="'panduan1'+key" class="con" :id="'panduan1-'+key">
              <!-- <b>{{'第 ' + (key+1) + ' 题'}}<span style="margin-left: 1.25rem;">({{item.score+'分'}})</span></b> -->
              <div class="option">
                <p class="optionitem" v-if="item.answer_status"> {{'第 ' + (key+1)+ ' 题 '}} ({{item.score+'分'}}){{item.name}}</p>
                <p class="optionitem"  style="color: red;"     v-else > {{'第 ' + (key+1)+ ' 题 '}} ({{item.score+'分'}}){{item.name}}</p>
                <el-radio-group v-model="temp[key]">
                  <el-radio label="1" disabled >正确</el-radio>
                  <el-radio label="0" disabled >错误</el-radio>
                </el-radio-group>
                <div class="optionanswer">
                <el-row>您的答案：{{item.user_choice}}</el-row>
                 <el-row>正确答案：{{item.answer}}</el-row>
                 <el-row style=" margin-top: 12px;">解 析：{{item.info}}</el-row>
                </div>
              </div>
            </div>
          </div>
          <div class="xz" v-if="subject.select_status">
            <div class="title">选 择</div>
            <div v-for="(item,key) in subject.selest" :key="'xuanze1'+key" class="con" :id="'xuanze1-'+key">
              <!-- <b >{{'第 ' + (key+1)+ ' 题 '}} <span style="margin-left: 1.25rem;">({{item.score+'分'}})</span></b> -->
              <div class="option">
                <p class="optionitem"  v-if="item.answer_status" >{{'第 ' + (key+1)+ ' 题 '}} ({{item.score+'分'}})  {{item.name}}</p>
                <p class="optionitem"  v-else style="color: red;" >{{'第 ' + (key+1)+ ' 题 '}} ({{item.score+'分'}})  {{item.name}}</p>
                  <el-checkbox  disabled v-for="(i,key1) in item['choice']"  :key="key1" :label="i" style="width: 100%;" >
                         {{options[key1]}}.{{i}}
                 </el-checkbox>
                 <div class="optionanswer" >
                   <p style=" margin-top: -12px;"> 您的答案：<nobr  v-for="(i1,key) in item['user_choice']" :key="key" >{{i1}}</nobr></p>
                    <p style=" margin-top: -12px;"> 正确答案：<nobr  v-for="(i1,key) in item['answer']" :key="key" >{{i1}}</nobr></p>
                    <span>解 析：{{item.info}}</span>
                 </div>
              </div>
            </div>
          </div>
        </div>
      </el-card>


      <div class=" rightcon right">
        <el-card class="box-card">
          <div class="rightconhead">
            <div>答题卡</div>
            <time>{{subject.score}}分</time>
          </div>
          <div class="right-con">
            <div class="detail">
              <div class="detailleft">总题数</div>
              <div class="">： {{subject.judge.length+subject.selest.length}}题</div>
            </div>
            <div style=" max-height: calc( 100vh - 340px); overflow: auto;">
               <div class="title" style="margin-top: 0;">判 断</div>
              <div class="num" v-if="subject.judge_status">
                 <el-button type="primary" plain v-for="(item,key) in subject.judge" :key="'panduan11'+key"  :id="'judge_local_'+key"  @click="buttonitem('#panduan1-'+key)">{{key+1}}</el-button>
              </div>
              <div class="title">选 择</div>
              <div class="num"  v-if="subject.select_status" >
                <el-button type="primary" plain   v-for="(item,key) in subject.selest" :key="'xaunze11'+key"  :id="'select_local_'+key" @click="buttonitem('#xuanze1-'+key)">{{key+1}}</el-button>
              </div>
            </div>

          </div>
          <el-button class="sub" type="primary" @click='goback()'>返回</el-button>
        </el-card>
      </div>



    </div>

  </div>
</template>

<script >

  export default {
    name: 'App',
     props: {
        time: {
            type: Number,
            default: 0
        }
    },
    data() {
      return {
        timeInterval: null,
        info:this.$store.state.info,
        showTime: this.time,
        timeText:'',
        options: ['A', 'B', 'C', 'D','E','F','G','H','I'],
        plan:{
          num:this.$route.query.num,
          type:'subject',
        },
        subject:{
          e_time:'',
          list:[],
          num:this.$route.query.num,
          judge_status:false,
          select_status:false,
          score:'',//的分数
          count:'',//总题数
          t:'',//答对题数
          name:'',
          judge:[],//判断
          selest:[],//选择
        },
        temp:{
          local:[],
          public:[]
        },
      }
    },
    components: {},

    mounted () {
       this.get_task_info();
    },
    updated(){
      let _this=this
      if(_this.subject.selest.length>0){
        for(let i=0;i<_this.subject.selest.length;i++){

          if( _this.subject.selest[i].answer_status){
            document.getElementById('select_local_'+i).style.backgroundColor="#00FF00"
          }else{
            document.getElementById('select_local_'+i).style.backgroundColor="red"
          }
        }
      }
      if(_this.subject.judge.length>0){
        for(let i=0;i< _this.subject.judge.length;i++){
          if( _this.subject.judge[i].answer_status){
            document.getElementById('judge_local_'+i).style.backgroundColor="#00FF00"
          }else{
            document.getElementById('judge_local_'+i).style.backgroundColor="red"
          }
        }
      }
    },
    methods: {
      goback(){
        window.close()
      },
        get_task_info(){
        let _this=this;
        _this.axios.get('/v2/user_evaluate/get_exam_info',{
          params: {num: _this.subject.num },}
        ).then(function(res) {
          if(res.status=='200'){
            if(res.data.code=='1'){
              _this.subject.list=res.data.data.list
               _this.subject.name=res.data.data.name
               _this.subject.score=res.data.data.score
               _this.set_info_list()
              if(_this.subject.judge.length>0){
                 _this.subject.judge_status=true;
                 _this.setxzitem('judge');
              }
              if(_this.subject.selest.length>0){
                _this.subject.select_status=true;
                _this.setxzitem('select');
              }
            }else{
              _this.$message.error(res.data.msg);
            }
          }else{
            _this.$message.error('服务器内部错误');
          }
        })
      },
      set_info_list(){
        let _this=this
        for(let i=0;i<_this.subject.list.length;i++){
          if(_this.subject.list[i].answer[0]==1  || _this.subject.list[i].answer[0]==0){
            _this.subject.judge.push(_this.subject.list[i])
          }else{
            _this.subject.selest.push(_this.subject.list[i])
          }
        }

      },
      //设置字符串
      setxzitem(type){
        let _this=this
        if(type=='select'){
        }else{
          for(let i=0;i< _this.subject.judge.length;i++){
            if(_this.subject.judge[i].answer == "0" ){
               _this.subject.judge[i].answer="错误"
            }else if(_this.subject.judge[i].answer == "1"){
                _this.subject.judge[i].answer="正确"
            }
            if(_this.subject.judge[i].user_choice[0] == "0" ){
               _this.subject.judge[i].user_choice="错误"
            }else if(_this.subject.judge[i].user_choice[0] == "1"){
                _this.subject.judge[i].user_choice="正确"
            }
          }
        }

      },
      //锚点跳转
      buttonitem(selector){
          var anchor = this.$el.querySelector(selector)
         document.documentElement.scrollTop =anchor.offsetTop
      },
    }

  }
</script>

<style scoped>
  /* 交卷 */
  >>>.sub {
    width: calc(100% - 40px);
    margin: 0px 20px;
  }

  >>>.el-checkbox__label {
    display: inline;
  }

  >>>.el-checkbox, .el-checkbox__input {
    white-space: normal;
  }

  .main {
    min-height: calc(100vh - 40px);
    height: 100%;
    width: 70%;
    padding: 20px;
    margin: 0 15%;
    z-index: 100;
    position: relative;
    overflow: hidden;
    :#2add9c
  }

  @media print {
    .rightcon{
      display: none;
    }
    .main{
      width: 100%;
      padding: 0;
      margin: 0;
    }
    .top_title{
      display: block !important;
    }
    .leftcon{
      width: inherit !important;
    }
  }

  .top_title{
    display: none;
  }

  /* 左侧 */
  .leftcon {
    width: calc(70% - 20px);
    padding: 0;
    background-color: white;
    min-height: calc(100vh - 40px);
    z-index: 1000;
    margin-bottom: 20px;
  }

  .left-con {
    padding: 20px;
    padding-top: 0;
  }

  .title {
    background-color: #f6f8ff;
    line-height: 50px;
    height: 50px;
    font-size: 18px;
    font-weight: 600;
    padding: 0 20px;
    margin-top: 20px;
  }

  .con {
    padding: 20px;
    margin: 3px 0;
    border: 1px solid gainsboro;
  }

  .option {
    padding-left: 20px;
  }

  .optionitem {
    border-bottom: 1px solid gainsboro;
    padding: 5px;
    margin-top: 0;
  }
  .optionanswer{
    font-size: 15px;
    margin-top: 20px;
  }

  /* 交卷 */
  >>>.sub {
    width: calc(100% - 40px);
    margin: 0px 20px;
  }

  /* 右侧 */
  .rightcon {
    width: 20%;
    background-color: white;
    position: fixed;
    top: 20px;
    right: 15%;
  }
  >>>.el-card__body {
    padding: 0;
    margin-bottom: 20px;
  }

  .right-con {
    padding: 20px;
  }

  .rightconhead {
    overflow: auto;
  }

  .detail {
    background-color: #f6f8ff;
    margin-bottom: 20px;
    padding: 20px;
  }

  .detailleft {
    width: 80px;
    margin-right: 10px;
    float: left;
    text-align-last:justify;
text-align:justify;
text-justify:distribute-all-lines;
  }

  time {
    background-color: #409EFF;
    width: 50%;
    float: right;
    height: 50px;
    line-height: 50px;
    text-align: center;
    color: #f50000;
    font-weight: 600;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }

  .rightconhead>div {
    float: left;
    width: 50%;
    height: 50px;
    line-height: 50px;
    text-align: center;
    font-weight: 600;
    background-color: #f6f8ff;
  }

  .num {
    padding: 0 10px;
    border: 2px solid #f6f8ff;
    border-top: none;
    width: calc( 100% - 24px );
    box-shadow: 5px 5px 5px #f6f8ff;
  }

  .num>.el-button {
    text-align: center;
    padding: 10px 5px;
    margin: 10px 5px;
    width: 35px;
    height: 35px;
  }
</style>



// WEBPACK FOOTER //
// src/view/company/evaluate/test_distribute_info/subjeCtresult.vue